import React, {FC, useContext} from 'react';
import {AsyncIdFilterInput, AsyncIdFilterInputProps} from "./AsyncIdFilterInput";
import {PROJECT_SELECT_API_ROUTE} from "../../../models/projects/Project";
import {LanguageContext} from "../../../config/ContextConfig";
import {projectFilterName} from "../../../models/common/DataFilter";

export interface ProjectFilterInputProps extends Omit< AsyncIdFilterInputProps, 'title' | 'route' | 'filterName'> {
    filterName?: string
}

// re-exported for the existing importers: the canonical home of the filter
// names is the model layer ( see DataFilter )
export {projectFilterName};

/**
 * ProjectFilterInput is a wrapper component around AsyncIdFilterInput
 *
 * it providers a select input to choose the project you want in the dataset from the API backend
 *
 * @see AsyncIdFilterInput
 *
 * @param props
 * @constructor
 */
export function ProjectFilterInput( props: ProjectFilterInputProps ) {
    const language = useContext( LanguageContext );

    return (
        <AsyncIdFilterInput
            {...props}
            title={language.projects.title}
            route={PROJECT_SELECT_API_ROUTE}
            filterName={props.filterName ?? projectFilterName }
        />
    );
}


